import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { TourSeenState } from './types';

const buildKey = (userId: string, tourId: string) => `${userId}:${tourId}`;

export const useTourStore = create<TourSeenState>()(
  persist(
    (set, get) => ({
      seen: {},
      markSeen: (userId, tourId) =>
        set((state) => ({
          seen: { ...state.seen, [buildKey(userId, tourId)]: true },
        })),
      hasSeen: (userId, tourId) => !!get().seen[buildKey(userId, tourId)],
      resetTour: (userId, tourId) =>
        set((state) => {
          const next = { ...state.seen };
          delete next[buildKey(userId, tourId)];
          return { seen: next };
        }),
      resetAllForUser: (userId) =>
        set((state) => {
          const next = { ...state.seen };
          Object.keys(next).forEach((key) => {
            if (key.startsWith(`${userId}:`)) delete next[key];
          });
          return { seen: next };
        }),
    }),
    { name: 'guided-tour-storage' }
  )
);
